import './OrganizationsTable.scss';

import { AsyncStateNotification } from '@ui/notifications';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { getOrganizationTableColumns } from './OrganizationsTableColumns';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { OrganizationMetadata } from '@sonar-software/sonar-core';
import { SonarTable } from '@ui/SonarTable';

import React, { useMemo } from 'react';
import {
	useAction,
	useCurrentUser,
	useInterval,
	useOrganizations,
	useSalesforceOrganizations,
	useUpdateOrganization
} from '@hooks';

const getRowKey = (organization: OrganizationMetadata) => organization.id;

export const OrganizationsTable: React.FC = () => {
	const organizations = useSalesforceOrganizations();
	const { isReadOnly } = useCurrentUser();

	const getAllOrganizations = useAction(useOrganizations.loadAction);

	useInterval(getAllOrganizations, 5000);

	const columns = useMemo(() => getOrganizationTableColumns(isReadOnly), [ isReadOnly ]);

	if (!organizations?.length) {
		return <LoadingSpinner spinning />;
	}

	return (
		<div id='organizations-table'>
			<SonarTable
				columns={ columns }
				dataSource={ organizations }
				pagination={ false }
				rowKey={ getRowKey }
				scroll={ { x: 'max-content' } }
				size='small' />
			<AsyncStateNotification
				errored={ COPY_GENERIC.UNHANDLED_ERROR }
				failed={ COPY_GENERIC.UNHANDLED_ERROR }
				stateSelector={ useUpdateOrganization.selectors.state } />
		</div>
	);
};
